import { Button, Card, CardBody, Flex, Text, Center } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { getSiteState, isOnline } from "../../../../../store/site/selectors";
import { CheckCircleIcon, WarningTwoIcon } from "@chakra-ui/icons";
import React from "react";
import { setSiteVisibility } from "../../../../../store/site/actions/setVisibility";
import { AppThunkDispatch } from "../../../../../store";

export default function SiteStatusBar() {
  const isSiteOnline = useSelector(isOnline);
  const siteState = useSelector(getSiteState);
  const dispatch = useDispatch<AppThunkDispatch>();

  return (
    <Center>
      <Card backgroundColor={isSiteOnline ? "green" : "red.600"}>
        <CardBody>
          <Flex alignItems="center">
            {isSiteOnline ? (
              <CheckCircleIcon mr="10px" color="talesWhite" />
            ) : (
              <WarningTwoIcon mr="10px" color="talesWhite" />
            )}
            <Text
              color="talesWhite"
              fontSize="1.1em"
              fontWeight="bold"
              mr="20px"
              w="120px"
            >
              Il sito{process.env.NODE_ENV === "development" ? " LOCALE" : ""} è{" "}
              {isSiteOnline ? "online" : "offline"}
            </Text>
            <Button onClick={() => dispatch(setSiteVisibility(siteState.data))}>
              Vai {isSiteOnline ? "OFFLINE" : "ONLINE"}
            </Button>
          </Flex>
        </CardBody>
      </Card>
    </Center>
  );
}
